import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { Shield, Building, MapPin, Clock, Eye, MessageSquare, Share2, ArrowLeft, FileText, AlertCircle } from 'lucide-react';
import { SocialShare } from '../../components/SocialShare';
export function AdvocacyPostDetailPage() {
  const {
    id
  } = useParams();
  const [showContactForm, setShowContactForm] = useState(false);
  const post = {
    id: id || '1',
    title: 'No Water Connection After 3 Years',
    author: 'Rajesh Kumar',
    authorInitials: 'RK',
    project: 'Lake View Plots',
    developer: 'Lake Developers',
    location: 'Pune',
    category: 'Infrastructure',
    status: 'Live',
    submittedDate: '2024-01-20',
    views: 234,
    comments: 12,
    verified: true,
    impactLevel: 'high',
    description: 'Despite taking possession 3 years ago, municipal water connection has not been provided. We are forced to rely on expensive tanker water costing ₹1,500 per week. Multiple complaints to developer have gone unanswered.',
    timeline: 'Booking: January 2020, Possession: March 2021, First Complaint: April 2021, RERA Complaint: October 2023, Current Status: Still waiting as of January 2024',
    actionsTaken: 'Sent 15+ emails to developer, Filed complaint with RERA, Consulted with lawyer, Organized buyer group meeting',
    desiredOutcome: 'Immediate municipal water connection or compensation for tanker water expenses',
    evidence: ['water_bills.pdf', 'complaint_emails.pdf', 'rera_complaint.pdf', 'site_photos.jpg']
  };
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-1653">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-1654">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-1655">
          <Link to="/" className="flex items-center gap-2" data-id="element-1656">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-1657"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-1658">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-1659">
            <Link to="/" data-id="element-1660">Buy Plots</Link>
            <Link to="/advocacy" className="text-[#1f2933]" data-id="element-1661">
              Advocacy
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1 max-w-5xl mx-auto px-6 py-12 w-full" data-id="element-1662">
        {/* Breadcrumb */}
        <div className="mb-6" data-id="element-1663">
          <Link to="/advocacy" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-1664">
            Advocacy
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-1665">/</span>
          <span className="text-sm text-gray-900" data-id="element-1666">Post #{post.id}</span>
        </div>

        <Link to="/advocacy" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6" data-id="element-1667">
          <ArrowLeft className="w-4 h-4" data-id="element-1668" />
          Back to Advocacy
        </Link>

        {/* Post Header */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-1669">
          <div className="flex items-center gap-3 mb-4" data-id="element-1670">
            {post.verified && <span className="px-3 py-1 bg-green-100 text-green-800 border border-green-200 text-xs font-bold rounded" data-id="element-1671">
                VERIFIED BUYER
              </span>}
            <span className="px-3 py-1 bg-blue-100 text-blue-800 border border-blue-200 text-xs font-bold rounded" data-id="element-1672">
              {post.status.toUpperCase()}
            </span>
            <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-1673">
              {post.category}
            </span>
            <span className={`px-3 py-1 text-xs font-bold rounded border ${post.impactLevel === 'high' ? 'bg-red-100 text-red-800 border-red-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200'}`} data-id="element-1674">
              {post.impactLevel === 'high' ? 'HIGH IMPACT' : 'MEDIUM IMPACT'}
            </span>
          </div>

          <h1 className="text-4xl font-bold mb-6" data-id="element-1675">{post.title}</h1>

          {/* Author & Project Info */}
          <div className="flex items-center gap-6 mb-6 pb-6 border-b border-gray-200" data-id="element-1676">
            <div className="flex items-center gap-3" data-id="element-1677">
              <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center font-bold" data-id="element-1678">
                {post.authorInitials}
              </div>
              <div data-id="element-1679">
                <div className="font-bold" data-id="element-1680">{post.author}</div>
                <div className="text-sm text-gray-500" data-id="element-1681">Verified Buyer</div>
              </div>
            </div>
            <div className="flex items-center gap-6 text-sm text-gray-600" data-id="element-1682">
              <span className="flex items-center gap-2" data-id="element-1683">
                <Building className="w-4 h-4" data-id="element-1684" />
                <span className="font-bold" data-id="element-1685">{post.project}</span>
              </span>
              <span className="flex items-center gap-2" data-id="element-1686">
                <MapPin className="w-4 h-4" data-id="element-1687" />
                {post.location}
              </span>
            </div>
          </div>

          {/* Stats */}
          <div className="flex items-center justify-between" data-id="element-1688">
            <div className="flex items-center gap-6 text-sm text-gray-500" data-id="element-1689">
              <span className="flex items-center gap-1" data-id="element-1690">
                <Clock className="w-4 h-4" data-id="element-1691" />
                {post.submittedDate}
              </span>
              <span className="flex items-center gap-1" data-id="element-1692">
                <Eye className="w-4 h-4" data-id="element-1693" />
                {post.views} views
              </span>
              <span className="flex items-center gap-1" data-id="element-1694">
                <MessageSquare className="w-4 h-4" data-id="element-1695" />
                {post.comments} comments
              </span>
            </div>
            <SocialShare url={window.location.href} title={post.title} description={post.description} data-id="element-1696" />
          </div>
        </div>

        {/* Post Content */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-1697">
          <h2 className="text-xl font-bold mb-4" data-id="element-1698">Issue Description</h2>
          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-1699">
            {post.description}
          </p>

          <h2 className="text-xl font-bold mb-4" data-id="element-1700">Timeline of Events</h2>
          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-1701">{post.timeline}</p>

          <h2 className="text-xl font-bold mb-4" data-id="element-1702">Actions Taken</h2>
          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-1703">
            {post.actionsTaken}
          </p>

          <h2 className="text-xl font-bold mb-4" data-id="element-1704">Desired Outcome</h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-1705">{post.desiredOutcome}</p>
        </div>

        {/* Evidence */}
        <div className="bg-white border border-gray-300 p-8 mb-6" data-id="element-1706">
          <h2 className="text-xl font-bold mb-4 flex items-center gap-2" data-id="element-1707">
            <FileText className="w-5 h-5" data-id="element-1708" />
            Supporting Evidence
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1709">
            {post.evidence.map((file, i) => <div key={i} className="p-4 border border-gray-200 bg-gray-50 text-center" data-id="element-1710">
                <FileText className="w-8 h-8 text-gray-400 mx-auto mb-2" data-id="element-1711" />
                <div className="text-xs font-bold text-gray-700 mb-1" data-id="element-1712">
                  {file}
                </div>
                <button className="text-xs text-blue-600 hover:underline" data-id="element-1713">
                  View
                </button>
              </div>)}
          </div>
        </div>

        {/* Contact Author */}
        <div className="bg-blue-50 border border-blue-200 p-6" data-id="element-1714">
          <div className="flex items-start gap-4" data-id="element-1715">
            <AlertCircle className="w-6 h-6 text-blue-600 shrink-0" data-id="element-1716" />
            <div className="flex-1" data-id="element-1717">
              <h3 className="font-bold mb-2" data-id="element-1718">Media & Civic Organizations</h3>
              <p className="text-sm text-gray-700 mb-4" data-id="element-1719">
                If you're a journalist or civic organization interested in this
                case, you can request to contact the author.
              </p>
              {!showContactForm ? <button onClick={() => setShowContactForm(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1720">
                  Request Contact Information
                </button> : <div className="space-y-3" data-id="element-1721">
                  <input type="text" placeholder="Your Name" className="w-full p-2 border border-gray-300 bg-white text-sm" data-id="element-1722" />
                  <input type="email" placeholder="Your Email" className="w-full p-2 border border-gray-300 bg-white text-sm" data-id="element-1723" />
                  <textarea placeholder="Purpose of contact..." rows={3} className="w-full p-2 border border-gray-300 bg-white text-sm" data-id="element-1724" />
                  <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1725">
                    Submit Request
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-1726" />
    </div>;
}